// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"630":"f538d049","658":"e6143e6a","896":"facaff98","945":"5c02dae1"}[chunkId] + ".chunk.js";
};